import React from "react";
import CustomCard from "../styleComp/CustomCard";
import InputAuthorization from "../component/Authentication/InputAuthorization";
import imageUrl from "../images/people2.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const gradientStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background:
    "linear-gradient(to bottom, rgba(255,255,255,0) 90%, rgba(255,255,255,1) 100%)",
};

const roundedImageStyle = {
  width: "100%",
  height: "30vh",
  objectFit: "cover",
  borderRadius: "20px",
};

const middleBoxStyle = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "50px",
  width: "170px",
  background: "white",
  borderRadius: "10px",
  marginBottom: "20px",
  top: "-50px",
  marginRight: "2rem",
  boxShadow: "inset 0px 4px 5px -2px rgba(0, 0, 0, 0.16)",
};



export default function AuthorizationPage() {
  return (
    <>
      <Box sx={{ display: { xs: "none", md: "block" }, containerStyle }}>
        <CustomCard widthCard={"90%"}>
          <div style={{ position: "relative", height: "30vh" }}>
            <img src={imageUrl} alt="Sample" style={roundedImageStyle} />
            <div style={gradientStyle}></div>
            <Box style={middleBoxStyle}>
              <Typography
                variant="h6"
              >
                זיהוי משתמש
              </Typography>
            </Box>
          </div>
          <InputAuthorization />
        </CustomCard>
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" }, containerStyle }}>
          <div style={{ position: "relative", height: "30vh" }}>
            <img src={imageUrl} alt="Sample" style={roundedImageStyle} />
            <div style={gradientStyle}></div>
            <Box style={middleBoxStyle}>
              <Typography
                variant="h6"
              >
                זיהוי משתמש
              </Typography>
            </Box>
          </div>
          <InputAuthorization />
      </Box>
    </>
  );
}
